import i18next from 'i18next';

import { PalletTypesFormProps } from 'interfaces';

export const palletTypesFormValidation = [
   ({ availablePalletTypes }: PalletTypesFormProps) => {
      if (availablePalletTypes.length === 0) {
         return {
            availablePalletTypes: i18next.t('sendPalletsModal.errors.chooseAtLeastOnePalletType'),
         };
      }
   },
];
